export default "__VITE_ASSET__Bb6u_K81__";